import React from "react";
import { useEnquiry } from "@/context/EnquiryContext";

export function Eyebrow({ children, className = "", dark = false }) {
  return (
    <span className={`font-mono text-xs font-semibold uppercase tracking-[0.25em] ${dark ? "text-orange-400" : "text-orange-500"} ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, center = false, dark = false, className = "" }) {
  return (
    <div className={`${center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} ${className}`}>
      {eyebrow && <Eyebrow dark={dark}>{eyebrow}</Eyebrow>}
      <h2 className={`mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="grad-navy relative overflow-hidden pt-32 pb-16 md:pt-40 md:pb-20">
      <div className="circuit-grid absolute inset-0 opacity-70" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-20 -top-10 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {eyebrow && <Eyebrow dark>{eyebrow}</Eyebrow>}
        <h1 className="mt-3 max-w-4xl font-display text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}

export function PrimaryButton({ children, onClick, className = "", ...props }) {
  return (
    <button onClick={onClick} className={`inline-flex items-center justify-center gap-2 rounded-xl bg-orange-500 px-6 py-3 text-sm font-semibold text-white shadow-md transition-all hover:bg-orange-600 hover:-translate-y-0.5 active:translate-y-0 md:text-base ${className}`} {...props}>
      {children}
    </button>
  );
}

export function RequestInfoButton({ interest = "Atmasamman Group", label = "Request Information", className = "", variant = "primary", testId }) {
  const { openEnquiry } = useEnquiry();
  const base = "inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold transition-all hover:-translate-y-0.5 md:text-base";
  const styles = variant === "primary"
    ? "bg-orange-500 text-white shadow-md hover:bg-orange-600"
    : variant === "dark"
      ? "bg-[#1C2541] text-white border border-white/15 hover:border-orange-500/50"
      : "border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white";
  return (
    <button onClick={() => openEnquiry({ interest })} data-testid={testId} className={`${base} ${styles} ${className}`}>
      {label}
    </button>
  );
}
